import { useContext, useEffect } from "react"
 
import axios from "axios"
import { useReducer ,useState } from "react";
import { Box, Button, Flex, Grid, GridItem, Heading } from '@chakra-ui/react'
import { Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react'
 
import { Spinner } from '@chakra-ui/react'
 
import { ProductReducer } from "../reducer/ProductReducer";
import ProductCardMen from "../Components/ProductsCardMen";
 
const initialState={
  products:[],
  isLoading:false,
  isErr:false
}
// const ProductReducer=(state,action)=>{
//   console.log(state,action.type)
//   switch(action.type){
//     case "FETCH_LOADING": 
//       return {
//          ...state,
//          isLoading: true ,
//          isError : false
//       }
   
//     case "FETCH_SUCCESS": 
//       return {
//          ...state,
//          products:action.payload,
//          isLoading: false,
//          isErr: false,
//       }
   
//     case "FETCH_FAILURE": 
//       return {
//          products:[],
//          isLoading:false,
//          isErr:  true,
//       }
   
//     default : 
//       throw new Error()
//   }
// }

export default   function  Men(){
  const [state, dispatch] = useReducer(ProductReducer,initialState);
  const {products,isLoading,isErr}=state;
  const[sortBy,setSortBy] = useState('asc');

  const getData= ()=> {
      dispatch({type : "FETCH_LOADING" })
      try {
       return axios.get(`https://mock-api-server-2399.onrender.com/men`)
        .then((res)=> dispatch({type : "FETCH_SUCCESS", payload : res.data}) )  
        
      } catch (error) {
        console.log("error !")
        dispatch({type : "FETCH_FAILURE", payload : []})
      }
    }
 
    useEffect(()=>{
      if(sortBy==="asc"){
        const Arr = [...products].sort((a,b)=> Number(a.MRP) - Number(b.MRP) )
         dispatch({type : "FETCH_SUCCESS", payload : [...Arr] })
      }
      else if(sortBy==="desc"){
        const Arr = [...products].sort((a,b)=> Number(b.MRP) - Number(a.MRP) )
         dispatch({type : "FETCH_SUCCESS", payload :  [...Arr] })
      }
      getData( );
    },[ sortBy])
 
 
  return   isLoading  ?            
         (
          <Spinner
          marginTop="300px"
          marginLeft="100px"
          marginBottom="100px"
          thickness='4px'
          speed='0.65s'
          emptyColor='gray.200'
          color='blue.500'
          size='xl'
        />
    )
    : 
          isErr ?   <h1>Something went Wrong ! </h1> :
      (
      <div>
         <Heading mt={3} fontSize={25}>Sort By Price </Heading>
        <Box gap={5}>
          <Button   m={5} isDisabled={sortBy==="asc"} onClick={()=> setSortBy("asc")}>ASC</Button>
          <Button   isDisabled={sortBy==="desc"} onClick={()=> setSortBy("desc")}>DESC</Button>
        </Box>
        <Grid  templateColumns="repeat(auto-fill, minmax(300px, 1fr))" gap={5} >
          {
            products?.length>0 && products.map((e,index)=>{
              return <GridItem key={Date.now()+e.src} w='100%'  >
                   <ProductCardMen
                      id={e.id}
                      category={e.category}
                      image={e.src}
                      price={e.MRP}
                      discount={e.discount}
                   />
              </GridItem>        
            })
          }
          </Grid>      
          {/* <Box>
                <Button isDisabled={page===1} onClick={()=> handlePage(-1)}>PREV</Button>
                <Button isDisabled={page===page}>{page}</Button>
                <Button isDisabled={page===3} onClick={()=> handlePage(1)}>NEXT</Button>
           </Box>  */}
      </div>
    )
  }
 
 
 